import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { MATCH_HUB_MAX_WIDTH } from './MatchHub.styles';

const CENTER_LANE_WIDTH = 148;

export function getMatchHubSkeletonStyles(theme: Theme) {
  return StyleSheet.create({
    root: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    /** Centered phone-width column (matches the loaded hub on large screens). */
    content: {
      width: '100%',
      maxWidth: MATCH_HUB_MAX_WIDTH,
      alignSelf: 'center',
    },
    hero: {
      position: 'relative',
      overflow: 'hidden',
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.xxxl,
      paddingHorizontal: theme.spacing.lg,
    },
    topBar: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: theme.spacing.xl,
    },
    topBarCenter: {
      flex: 1,
      alignItems: 'center',
      paddingHorizontal: theme.spacing.sm,
      gap: 4,
    },
    topBarSpacer: {
      width: 40,
    },
    kitsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing.sm,
    },
    kitSlot: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    centerLane: {
      width: CENTER_LANE_WIDTH,
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
    },
    namesRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 2,
    },
    nameSide: {
      flex: 1,
      alignItems: 'center',
      paddingHorizontal: theme.spacing.xs,
    },
    nameCenterSlot: {
      width: CENTER_LANE_WIDTH,
      alignItems: 'center',
    },
    tabBar: {
      flexDirection: 'row',
      backgroundColor: theme.primaryDark,
      marginHorizontal: theme.spacing.lg,
      marginTop: -theme.spacing.md,
      marginBottom: theme.spacing.md,
      borderRadius: theme.borderRadius.lg,
      padding: 4,
      gap: 4,
    },
    tabPill: {
      flex: 1,
      height: 34,
      borderRadius: theme.borderRadius.md,
    },
    tabPillActive: {
      backgroundColor: theme.primaryLight,
      opacity: 0.5,
    },
    cards: {
      paddingHorizontal: theme.spacing.sm,
      gap: 10,
    },
  });
}
